import React from "react";
import { Box, Divider } from "@material-ui/core";
import { ButtonLoader, IntroText, Loader } from "../../../components";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const ScheduleGroupCodeScreener = ({ handleResponse, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) return <Loader />;

  return (
    <Box data-cy="schedule-group-code-screener">
      <IntroText>{t("schedule.group_code_screener.intro_text")}</IntroText>
      <Box mb={2} textAlign="center">
        <Alert icon={false} color="info">
          {t("schedule.group_code_screener.secondary_text")}
        </Alert>
      </Box>
      <ButtonLoader
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        data-cy="group-code-no"
        onClick={e => handleResponse("no")}
        loading={isLoading}
      >
        {t("schedule.group_code_screener.options.no")}
      </ButtonLoader>
      <Box my={2}>
        <Divider variant="middle" />
      </Box>
      <ButtonLoader
        variant="contained"
        fullWidth
        size="large"
        data-cy="group-code-yes"
        onClick={e => handleResponse("yes")}
        loading={isLoading}
      >
        {t("schedule.group_code_screener.options.yes")}
      </ButtonLoader>
    </Box>
  );
};

export { ScheduleGroupCodeScreener };
